<template>
  <div>
    <!-- 작업기간 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>작업기간</span></label>
      <div class="col-6 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          v-model="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          style="font-size: 12px;"
          input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>

    <!-- 운전원 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>운전원</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="permit.operators.push({ name: '', license: '', phone: '' })">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
          <button class="btn btn-md line-2" @click="$emit('load-operators')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col><col><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr><th>성명</th><th>면허</th><th>연락처</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="(op, idx) in permit.operators" :key="idx">
              <td><input type="text" class="form-control" v-model="op.name" placeholder="성명"></td>
              <td><input type="text" class="form-control" v-model="op.license" placeholder="면허종류"></td>
              <td><input type="text" class="form-control" v-model="op.phone" placeholder="연락처"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="permit.operators.splice(idx,1)" :disabled="permit.operators.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 유도자 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>유도자</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="permit.guides.push({ name: '', signalMethods: [], phone: '', wirelessMeans: '' })">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
          <button class="btn btn-md line-2" @click="$emit('load-guides')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col><col><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr><th>성명</th><th>신호방법</th><th>연락처</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="(guide, idx) in permit.guides" :key="idx">
              <td><input type="text" class="form-control" v-model="guide.name" placeholder="성명"></td>
              <td style="vertical-align:middle;">
                <label class="md-check mr-20"><input type="checkbox" v-model="guide.signalMethods" value="수신호"><i class="blue"></i>수신호</label>
                <label class="md-check"><input type="checkbox" v-model="guide.signalMethods" value="무선"><i class="blue"></i>무선</label>
                <input v-if="guide.signalMethods && guide.signalMethods.includes('무선')" type="text" class="form-control mt-5" v-model="guide.wirelessMeans" placeholder="무선수단 입력 (예: 무전기/채널)">
              </td>
              <td><input type="text" class="form-control" v-model="guide.phone" placeholder="연락처"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="permit.guides.splice(idx,1)" :disabled="permit.guides.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 기계·장비 제원 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>기계·장비 제원</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md line-2" @click="$emit('load-equipment')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <div v-for="(equip, eIdx) in permit.equipmentList" :key="equip.id" class="box mb-10">
          <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
            <span style="font-weight:600;">장비 {{ eIdx + 1 }}</span>
            <button class="btn btn-xs line-2" @click="permit.equipmentList.splice(eIdx,1)"
              :disabled="permit.equipmentList.length === 1">삭제</button>
          </div>
          <div class="box-body">
            <!-- 장비 종류 -->
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">장비 종류</label>
              <div class="col-10">
                <label class="md-check mr-20"><input type="radio" v-model="equip.equipType" value="카고크레인"><i class="blue"></i>카고크레인</label>
                <label class="md-check mr-20"><input type="radio" v-model="equip.equipType" value="기중기"><i class="blue"></i>기중기</label>
              </div>
            </div>

            <!-- 건설기계등록증 (공통) -->
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0"><span class="ess">건설기계등록증</span></label>
              <div class="col-10">
                <label class="md-check mr-20"><input type="radio" v-model="equip.hasCertificate" :value="true"><i class="blue"></i>유</label>
                <label class="md-check mr-20"><input type="radio" v-model="equip.hasCertificate" :value="false"><i class="blue"></i>무</label>
              </div>
            </div>

            <!-- 카고크레인 -->
            <template v-if="equip.equipType === '카고크레인'">
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">자동차등록번호</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.vehicleRegNo" placeholder="00가 0000"></div>
                <label class="col-2 form-control-label pt-0">차종</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.vehicleType" placeholder="대형화물"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">차명(비고 구조변경)</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.vehicleName" placeholder="뉴파워 트럭(물품적재장치)"></div>
                <label class="col-2 form-control-label pt-0">형식 및 모델연도</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.modelTypeYear" placeholder="HD25CT-0000(2006)"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">구조변경일</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.modificationDate" placeholder="00-00-00 유압크레인"></div>
                <label class="col-2 form-control-label pt-0">구조변경업체</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.modificationCompany" placeholder="(주) 00특장"></div>
              </div>

              <!-- 보험여부 -->
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">보험여부</span></label>
                <div class="col-10" style="display:flex;align-items:center;">
                  <label class="md-check mr-20"><input type="radio" v-model="equip.insuranceStatus" value="가입"><i class="blue"></i>가입</label>
                  <label class="md-check mr-20"><input type="radio" v-model="equip.insuranceStatus" value="미가입"><i class="blue"></i>미가입</label>
                  <input v-if="equip.insuranceStatus === '가입'" type="text" class="form-control" v-model="equip.insuranceName" placeholder="보험사명" style="max-width:200px;">
                </div>
              </div>
              <div class="form-group row mb-10" v-if="equip.insuranceStatus === '가입'">
                <label class="col-2 form-control-label pt-0">보험 유효기간</label>
                <div class="col-4"><DatePicker class="form-control" type="date" :append-to-body="true"
                    v-model="equip.insuranceExpiry"
                    value-type="format" format="YYYY-MM-DD"
                    :clearable="false" :editable="false"
                    style="font-size: 12px; width: 100%;"
                    input-class="calendar-input">
                    <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                  </DatePicker></div>
              </div>

              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">종류</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.craneType" placeholder="신축형(2010)"></div>
                <label class="col-2 form-control-label pt-0">아웃트리거 최대 폭</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.outriggerWidth" placeholder="앞: 0,000 / 뒤: 0,000 mm"></div>
              </div>

              <!-- 작업능력 -->
              <div class="mt-15 mb-10" style="font-weight:600;border-bottom:1px solid #e2e2e2;padding-bottom:6px;">작업능력</div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">최대 작업높이</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.maxWorkHeight" placeholder="00 m"></div>
                <label class="col-2 form-control-label pt-0">최대 작업반경</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.maxWorkRadius" placeholder="00 m"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">정격하중</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.ratedLoad" placeholder="10 ton"></div>
              </div>

              <!-- 안전검사 -->
              <div class="mt-15 mb-10" style="font-weight:600;border-bottom:1px solid #e2e2e2;padding-bottom:6px;">안전검사</div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">검사기관</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.inspectionAgency" placeholder="한국 승강기안전공단"></div>
                <label class="col-2 form-control-label pt-0">조작방식</label>
                <div class="col-4" style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
                  <label class="md-check"><input type="checkbox" v-model="equip.operationMethods" value="조정석"><i class="blue"></i>조정석</label>
                  <label class="md-check"><input type="checkbox" v-model="equip.operationMethods" value="펜던트스위치"><i class="blue"></i>펜던트스위치</label>
                </div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">정기검사일</label>
                <div class="col-4"><DatePicker class="form-control" type="date" :append-to-body="true"
                    v-model="equip.regularInspectionDate"
                    value-type="format" format="YYYY-MM-DD"
                    :clearable="false" :editable="false"
                    style="font-size: 12px; width: 100%;"
                    input-class="calendar-input">
                    <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                  </DatePicker></div>
                <label class="col-2 form-control-label pt-0">검사 유효기간</label>
                <div class="col-4"><DatePicker class="form-control" type="date" :append-to-body="true"
                    v-model="equip.inspectionExpiry"
                    value-type="format" format="YYYY-MM-DD"
                    :clearable="false" :editable="false"
                    style="font-size: 12px; width: 100%;"
                    input-class="calendar-input">
                    <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                  </DatePicker></div>
              </div>
            </template>

            <!-- 기중기 -->
            <template v-if="equip.equipType === '기중기'">
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">건설기계명</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.machineName" placeholder="기중기"></div>
                <label class="col-2 form-control-label pt-0">등록번호</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.registrationNo" placeholder="007가 0000"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">규격</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.machineSpec" placeholder="75 ton 2.3m"></div>
                <label class="col-2 form-control-label pt-0">제작년도</label>
                <div class="col-4" style="display:flex;align-items:center;gap:6px;">
                  <input type="text" class="form-control" v-model="equip.manufactureYear" placeholder="0000">
                  <span>년</span>
                </div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">업체명</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.manufacturer" placeholder="00 중기"></div>
              </div>

              <!-- 보험여부 -->
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">보험여부</span></label>
                <div class="col-10" style="display:flex;align-items:center;">
                  <label class="md-check mr-20"><input type="radio" v-model="equip.insuranceStatus" value="가입"><i class="blue"></i>가입</label>
                  <label class="md-check mr-20"><input type="radio" v-model="equip.insuranceStatus" value="미가입"><i class="blue"></i>미가입</label>
                  <input v-if="equip.insuranceStatus === '가입'" type="text" class="form-control" v-model="equip.insuranceName" placeholder="보험사명" style="max-width:200px;">
                </div>
              </div>
              <div class="form-group row mb-10" v-if="equip.insuranceStatus === '가입'">
                <label class="col-2 form-control-label pt-0">보험 유효기간</label>
                <div class="col-4"><DatePicker class="form-control" type="date" :append-to-body="true"
                    v-model="equip.insuranceExpiry"
                    value-type="format" format="YYYY-MM-DD"
                    :clearable="false" :editable="false"
                    style="font-size: 12px; width: 100%;"
                    input-class="calendar-input">
                    <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                  </DatePicker></div>
              </div>

              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">길이</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.length" placeholder="00000 mm"></div>
                <label class="col-2 form-control-label pt-0">너비</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.width" placeholder="0000 mm"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">높이</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.height" placeholder="0000 mm"></div>
                <label class="col-2 form-control-label pt-0">주행방식</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.driveType" placeholder="자주식(타이어식)"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">정기검사일</label>
                <div class="col-4"><DatePicker class="form-control" type="date" :append-to-body="true"
                    v-model="equip.regularInspectionDate"
                    value-type="format" format="YYYY-MM-DD"
                    :clearable="false" :editable="false"
                    style="font-size: 12px; width: 100%;"
                    input-class="calendar-input">
                    <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                  </DatePicker></div>
                <label class="col-2 form-control-label pt-0">검사 유효기간</label>
                <div class="col-4"><DatePicker class="form-control" type="date" :append-to-body="true"
                    v-model="equip.inspectionExpiry"
                    value-type="format" format="YYYY-MM-DD"
                    :clearable="false" :editable="false"
                    style="font-size: 12px; width: 100%;"
                    input-class="calendar-input">
                    <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                  </DatePicker></div>
              </div>

              <!-- 기종별 작업장치 -->
              <div class="mt-15 mb-10" style="font-weight:600;border-bottom:1px solid #e2e2e2;padding-bottom:6px;">기종별 작업장치</div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">표준붐의 작업반경</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.standardBoomRadius" placeholder="2.3m~38m"></div>
                <label class="col-2 form-control-label pt-0"><span class="ess">붐길이(최대)</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.boomLengthMax" placeholder="45m"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">붐의 최대각도</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.boomMaxAngle" placeholder="84도"></div>
                <label class="col-2 form-control-label pt-0"><span class="ess">최대정격(총하중)</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.maxRatedLoad" placeholder="75,000 kg"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">붐의 최소각도</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.boomMinAngle" placeholder="00도"></div>
                <label class="col-2 form-control-label pt-0">최소정격(하중)</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.minRatedLoad" placeholder="0,000 kg"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">훅 최대 지상높이</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.hookMaxHeight" placeholder="00m"></div>
                <label class="col-2 form-control-label pt-0">아웃트리거 설치폭</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.outriggerSize" placeholder="0,000 x 0,000 mm (가로x세로)"></div>
              </div>
            </template>
          </div>
        </div>
        <button class="btn btn-md light-blue" @click="addEquipment">
          <i class="icon-plus mr-5"></i>장비 추가
        </button>
      </div>
    </div>

    <!-- 인양작업 줄걸이 용구 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>인양작업 줄걸이 용구</span></label>
      <div class="col-10 pt-2">
        <div class="mb-10" style="display:flex;align-items:center;gap:12px;">
          <label class="md-check" style="margin:0;"><input type="checkbox" v-model="permit.hasRigging" checked disabled><i class="blue"></i>줄걸이 사용</label>
          <button class="btn btn-sm line-2" @click="$emit('load-lifting')">
            <i class="icon-refresh mr-3"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <div v-for="(lift, lIdx) in permit.liftingList" :key="lift.id" class="box mb-10">
          <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
            <span style="font-weight:600;">줄걸이 {{ lIdx + 1 }}</span>
            <button class="btn btn-xs line-2" @click="removeLifting(lIdx)"
              :disabled="permit.liftingList.length === 1">삭제</button>
          </div>
          <div class="box-body">
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">인양능력 검토 결과</label>
              <div class="col-10">
                <span class="text-888 mr-15" style="font-size:11px;">줄걸이 용구 최대 사용하중 &gt; 중량물 하중</span>
                <label class="md-check mr-20"><input type="radio" v-model="lift.liftFeasible" value="인양가능"><i class="blue"></i>인양 가능</label>
                <label class="md-check mr-20"><input type="radio" v-model="lift.liftFeasible" value="인양불가능"><i class="blue"></i>인양 불가능</label>
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">줄걸이 용구</label>
              <div class="col-10">
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="와이어로프"><i class="blue"></i>와이어로프</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="섬유로프"><i class="blue"></i>섬유로프</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="체인"><i class="blue"></i>체인</label>
                <label class="md-check mr-10"><input type="checkbox" v-model="lift.riggingToolOther"><i class="blue"></i>기타</label>
                <input v-if="lift.riggingToolOther" type="text" class="form-control mt-5" v-model="lift.riggingToolOtherText" placeholder="기타 줄걸이 용구" style="max-width:300px;">
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">보조용구</label>
              <div class="col-10">
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="클램프"><i class="blue"></i>클램프</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="해커"><i class="blue"></i>해커</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="체인슬링"><i class="blue"></i>체인슬링</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="러그"><i class="blue"></i>러그</label>
                <label class="md-check mr-10"><input type="checkbox" v-model="lift.auxiliaryToolOther"><i class="blue"></i>기타</label>
                <input v-if="lift.auxiliaryToolOther" type="text" class="form-control mt-5" v-model="lift.auxiliaryToolOtherText" placeholder="기타 보조용구" style="max-width:300px;">
              </div>
            </div>
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0">줄걸이 세부</label>
              <div class="col-10">
                <div class="row">
                  <div class="col-4 mb-10"><label class="wp-field-label">직경</label><input type="text" class="form-control" v-model="lift.diameter" placeholder="00 mm"></div>
                  <div class="col-4 mb-10"><label class="wp-field-label">안전작업하중</label><input type="text" class="form-control" v-model="lift.safeWorkLoad" placeholder="00개"></div>
                  <div class="col-4 mb-10"><label class="wp-field-label">줄걸이 수</label><input type="text" class="form-control" v-model="lift.riggingCount"></div>
                  <div class="col-4"><label class="wp-field-label">하중계수(장력)</label><input type="text" class="form-control" v-model="lift.loadFactor"></div>
                  <div class="col-4"><label class="wp-field-label">안전계수</label><input type="text" class="form-control" v-model="lift.safetyFactor"></div>
                  <div class="col-4"><label class="wp-field-label">최대사용하중</label><input type="text" class="form-control" v-model="lift.maxWorkLoad"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-md light-blue" @click="addLifting"><i class="icon-plus mr-5"></i>줄걸이 추가</button>
      </div>
    </div>

    <!-- 중량물 제원 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>중량물 제원</span></label>
      <div class="col-10 pt-2">
        <div class="mb-10" style="display:flex;align-items:center;gap:12px;">
          <label class="md-check" style="margin:0;"><input type="checkbox" v-model="permit.hasHeavyCargo" checked disabled><i class="blue"></i>중량물 취급</label>
          <button class="btn btn-sm line-2" @click="$emit('load-cargo')">
            <i class="icon-refresh mr-3"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <div v-for="(cargo, cIdx) in permit.cargoList" :key="cargo.id" class="box mb-10">
          <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
            <span style="font-weight:600;">중량물 {{ cIdx + 1 }}</span>
            <button class="btn btn-xs line-2" @click="permit.cargoList.splice(cIdx,1)"
              :disabled="permit.cargoList.length === 1">삭제</button>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-4 mb-10"><label class="wp-field-label">품명</label><input type="text" class="form-control" v-model="cargo.name" placeholder="철근(상세제원 다발)"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">단위중량(kg)</label><input type="text" class="form-control" v-model="cargo.unitWeight" placeholder="00 kg"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">종류</label><input type="text" class="form-control" v-model="cargo.type" placeholder="철근 다발, 거푸집 등"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">고정방법</label><input type="text" class="form-control" v-model="cargo.fixMethod"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">형상</label><input type="text" class="form-control" v-model="cargo.shape" placeholder="박스형, 묶음형 등"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">총중량(kg)</label><input type="text" class="form-control" v-model="cargo.totalWeight" placeholder="00 kg"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">수직 운반거리(m)</label><input type="text" class="form-control" v-model="cargo.verticalDistance" placeholder="00 m"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">수평 운반거리(m)</label><input type="text" class="form-control" v-model="cargo.horizontalDistance" placeholder="00 m"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">필요작업반경(m)</label><input type="text" class="form-control" v-model="cargo.workRadius" placeholder="00 m"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">총 양중수량(개)</label><input type="text" class="form-control" v-model="cargo.totalQty" placeholder="00 개"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">1회 양중수량(개)</label><input type="text" class="form-control" v-model="cargo.qtyPerLift" placeholder="00 개"></div>
              <div class="col-4 mb-0"><label class="wp-field-label">1회 양중중량(kg)</label><input type="text" class="form-control" v-model="cargo.weightPerLift" placeholder="00 kg"></div>
            </div>
          </div>
        </div>
        <button class="btn btn-md light-blue" @click="addCargo"><i class="icon-plus mr-5"></i>중량물 추가</button>
      </div>
    </div>

    <!-- 작업장소 사전 조사 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>작업장소의 지형·지반 상태 등 사전 조사내용</span></label>
      <div class="col-10 pt-2">
        <!-- 작업장소의 지형·지반 상태 -->
        <div class="form-group row mb-10">
          <label class="col-2 form-control-label pt-0">작업장소의 지형·지반 상태</label>
          <div class="col-10">
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">지반 종류</label>
              <div class="col-10" style="display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px;">
                <label class="md-check mr-15" v-for="g in ['모래','흙','아스팔트','보도블럭']" :key="g">
                  <input type="checkbox" v-model="permit.siteInvestigation.groundTypes" :value="g"><i class="blue"></i>{{ g }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.groundTypeOther"><i class="blue"></i>기타</label>
                <input v-if="permit.siteInvestigation.groundTypeOther" type="text" class="form-control"
                       v-model="permit.siteInvestigation.groundTypeOtherText" placeholder="기타 지반 종류" style="max-width:200px;">
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">지반상태</label>
              <div class="col-10" style="display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px;">
                <label class="md-check mr-15" v-for="c in ['견고','연약','동결']" :key="c">
                  <input type="checkbox" v-model="permit.siteInvestigation.conditions" :value="c"><i class="blue"></i>{{ c }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.slopeCheck"><i class="blue"></i>경사</label>
                <input v-if="permit.siteInvestigation.slopeCheck" type="text" class="form-control"
                       v-model="permit.siteInvestigation.slopeText" placeholder="1:1" style="width:80px;">
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.specialNoteCheck"><i class="blue"></i>특이사항</label>
                <input v-if="permit.siteInvestigation.specialNoteCheck" type="text" class="form-control"
                       v-model="permit.siteInvestigation.specialNoteText" placeholder="특이사항 입력" style="max-width:200px;">
              </div>
            </div>
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0">지반 보강방법</label>
              <div class="col-10">
                <label class="md-check mr-15" v-for="r in ['철판설치','지반개량','양질토사','성토','해당없음']" :key="r">
                  <input type="checkbox" v-model="permit.siteInvestigation.reinforcementMethods" :value="r"><i class="blue"></i>{{ r }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.reinforcementOther"><i class="blue"></i>기타</label>
                <input v-if="permit.siteInvestigation.reinforcementOther" type="text" class="form-control mt-5"
                       v-model="permit.siteInvestigation.reinforcementOtherText" placeholder="기타 보강방법" style="max-width:300px;">
              </div>
            </div>
          </div>
        </div>

        <!-- 주변작업·이동 및 지장물 간섭 -->
        <div class="form-group row mt-15 mb-0">
          <label class="col-2 form-control-label pt-0">주변작업·이동 및 지장물 간섭</label>
          <div class="col-10">
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">작업반경 내 출입금지 조치</label>
              <div class="col-10">
                <label class="md-check mr-15" v-for="a in ['유도자','접근방지 로프','칼라콘']" :key="a">
                  <input type="checkbox" v-model="permit.siteInvestigation.accessRestrictions" :value="a"><i class="blue"></i>{{ a }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.accessRestrictionOther"><i class="blue"></i>기타</label>
                <input v-if="permit.siteInvestigation.accessRestrictionOther" type="text" class="form-control mt-5"
                       v-model="permit.siteInvestigation.accessRestrictionOtherText" placeholder="기타 조치" style="max-width:300px;">
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">주변 가공전선 접촉 가능 여부</label>
              <div class="col-10" style="display:flex;align-items:center;gap:12px;">
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.nearbyPowerLines" value="있음"><i class="blue"></i>있음</label>
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.nearbyPowerLines" value="없음"><i class="blue"></i>없음</label>
                <input v-if="permit.siteInvestigation.nearbyPowerLines === '있음'" type="text" class="form-control"
                       v-model="permit.siteInvestigation.nearbyPowerLinesMeasure" placeholder="조치내용" style="flex:1;min-width:0;">
              </div>
            </div>
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0">주변 지장물 간섭 여부</label>
              <div class="col-10" style="display:flex;align-items:center;gap:12px;">
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.nearbyObstacle" value="있음"><i class="blue"></i>있음</label>
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.nearbyObstacle" value="없음"><i class="blue"></i>없음</label>
                <input v-if="permit.siteInvestigation.nearbyObstacle === '있음'" type="text" class="form-control"
                       v-model="permit.siteInvestigation.nearbyObstacleMeasure" placeholder="조치내용" style="flex:1;min-width:0;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 작업순서 및 안전 작업 방법 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>작업순서 및 안전 작업 방법</span></label>
      <div class="col-10 pt-2">
        <WorkProcedureTable :procedures="permit.procedures" @load-procedures="$emit('load-procedures')" />
      </div>
    </div>

    <!-- 첨부서류 목록 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>첨부서류 목록</span></label>
      <div class="col-10 pt-2">
        <div v-for="doc in permit.attachmentDocs" :key="doc.key" class="mb-10">
          <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
            <label class="md-check" style="min-width:220px;">
              <input type="checkbox" v-model="doc.checked"><i class="blue"></i>{{ doc.label }}
            </label>
            <template v-if="doc.checked">
              <input type="file" multiple :id="'crane-doc-' + doc.key" style="display:none;"
                @change="handleDocFile($event, doc)">
              <button class="btn btn-sm line-2" @click="$el.querySelector('#crane-doc-' + doc.key).click()"
                :disabled="doc.maskingChecking">
                <i class="icon-upload mr-3"></i>파일 선택
              </button>
              <span v-if="doc.maskingChecking" class="text-info" style="font-size:11px;">
                <i class="fa fa-spinner fa-spin mr-3"></i>AI 가 개인정보 마스킹 여부를 확인하는 중입니다... (최대 1분 소요)
              </span>
              <div v-if="doc.rejections && doc.rejections.length" class="mt-5"
                   style="width:100%; padding:8px 10px; background:#fff5f5; border:1px solid #f5c6cb; border-radius:4px; font-size:11px; color:#721c24;">
                <div v-for="(r, ri) in doc.rejections" :key="'rej-'+ri" :class="ri ? 'mt-3' : ''">
                  <strong>[{{ r.fileName }}] 업로드 거부 — 개인정보 마스킹 미흡</strong>
                  <span v-if="r.documentSubtype"> · {{ r.documentSubtype }}</span>
                  <span v-if="r.confidence != null"> · 신뢰도 {{ Math.round(r.confidence * 100) }}%</span>
                  <span v-if="r.totalCount"> · AI {{ r.totalCount }}회 중 {{ r.rejectedCount }}회 거절</span>
                  <div>· 노출된 항목 : {{ r.exposedFields.length ? r.exposedFields.join(', ') : '(미상)' }}</div>
                  <div>· AI 평가     : {{ r.overallAssessment }}</div>
                </div>
              </div>
              <div v-if="doc.maskingError" class="mt-5" style="width:100%; padding:6px 10px; background:#fff3cd; border:1px solid #ffeeba; border-radius:4px; font-size:11px; color:#856404;">
                {{ doc.maskingError }}
              </div>
              <div v-if="doc.files && doc.files.length" style="display:flex;flex-wrap:wrap;gap:4px;">
                <span v-for="(f, fi) in doc.files" :key="fi"
                  style="font-size:11px;background:#f0f0f0;padding:2px 6px;border-radius:3px;display:flex;align-items:center;gap:4px;">
                  {{ f.name }}
                  <button class="btn btn-xs line-2" style="padding:0 4px;height:16px;line-height:14px;" @click="doc.files.splice(fi,1)">×</button>
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkProcedureTable from './WorkProcedureTable.vue';
import docFileUploadMixin from '@/mixins/docFileUploadMixin';
export default {
  name: 'MobileCranePermit',
  components: { WorkProcedureTable },
  mixins: [docFileUploadMixin],
  inject: { workPermitPlanId: { default: () => '' } },
  data() { return { workPermitFormKey: 'mobileCranePermit' }; },
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    },
    signalMethodOptions: {
      type: Array,
      default: () => ['수신호', '무선', '기타']
    }
  },
  methods: {
    addEquipment() {
      this.permit.equipmentList.push({
        id: Date.now(),
        equipType: '카고크레인',
        hasCertificate: null,
        insuranceStatus: '', insuranceName: '', insuranceExpiry: '',
        regularInspectionDate: '', inspectionExpiry: '',
        // 카고크레인
        vehicleRegNo: '', vehicleType: '', vehicleName: '', modelTypeYear: '',
        modificationDate: '', modificationCompany: '',
        craneType: '', outriggerWidth: '',
        maxWorkHeight: '', maxWorkRadius: '', ratedLoad: '',
        inspectionAgency: '', operationMethods: [],
        // 기중기
        machineName: '', registrationNo: '', machineSpec: '',
        manufactureYear: '', manufacturer: '',
        length: '', width: '', height: '', driveType: '',
        standardBoomRadius: '', boomLengthMax: '', boomMaxAngle: '',
        maxRatedLoad: '', boomMinAngle: '', minRatedLoad: '',
        hookMaxHeight: '', outriggerSize: ''
      });
    },
    addLifting() {
      this.permit.liftingList.push({ id: Date.now(), liftFeasible: '', riggingTools: [], riggingToolOther: false, riggingToolOtherText: '', auxiliaryTools: [], auxiliaryToolOther: false, auxiliaryToolOtherText: '', diameter: '', safeWorkLoad: '', riggingCount: '', loadFactor: '', safetyFactor: '', maxWorkLoad: '' });
    },
    removeLifting(index) {
      if (this.permit.liftingList.length > 1) this.permit.liftingList.splice(index, 1);
    },
    addCargo() {
      this.permit.cargoList.push({ id: Date.now(), name: '', unitWeight: '', type: '', fixMethod: '', shape: '', totalWeight: '', verticalDistance: '', horizontalDistance: '', workRadius: '', totalQty: '', qtyPerLift: '', weightPerLift: '' });
    },
    removeCargo(index) {
      if (this.permit.cargoList.length > 1) this.permit.cargoList.splice(index, 1);
    },
  }
}
</script>